<div>
  <div class="gb-dialog-header">
    <h1 translate="USERS.MESSAGE.TITLE"></h1>

    <button mat-icon-button mat-dialog-close>
      <gb-icon icon="close"></gb-icon>
    </button>
  </div>

  <div class="gb-dialog-content message-user-dialog-content">
    <div class="recipient-container">
      <span translate="USERS.MESSAGE.TO_LABEL"></span>
      <mat-chip-row class="recipient-chip">
        <mat-icon matChipAvatar>account_circle</mat-icon>
        <span>{{ data.profile | gbDisplayName }}</span>
      </mat-chip-row>
    </div>

    <gb-message-placeholders [placeholders]="placeholders"></gb-message-placeholders>

    <form [formGroup]="messageUserForm">
      <mat-form-field subscriptSizing="fixed">
        <mat-label translate="MESSAGE"></mat-label>
        <textarea
          matInput
          cdkTextareaAutosize
          cdkAutosizeMinRows="4"
          cdkAutosizeMaxRows="10"
          formControlName="message_template"
        ></textarea>
      </mat-form-field>
    </form>
  </div>
  <div class="gb-dialog-actions-container gb-flex-button-container">
    <button mat-stroked-button type="button" translate="CANCEL" mat-dialog-close></button>
    <button mat-flat-button (click)="submitForm()" [disabled]="(messageLoaded$ | async) === false">
      <gb-button-loader [loaded$]="messageLoaded$">
        <span translate="SEND"></span>
      </gb-button-loader>
    </button>
  </div>
</div>
